import { MessageBox } from 'dygc-ui'

export function confirm(message, opt = {}) {
  const { confirm, close } = opt
  MessageBox.alert(message, '提示', {
    confirmButtonText: '确认无误',
    cancelButtonText: '修改',
    type: 'warning',
    showCancelButton: true
  })
    .then(() => {
      confirm && confirm()
    })
    .catch(() => {
      close && close()
    })
}